<content-block [title]="'Preference.ReleveAffaire.Title' | translate" [headerActions]="contentBlockActions" classList="has-spacer">
	<form [formGroup]="form" *ngIf="form">
		<div class="toggle-container">
			<label for="" class="form-label" for="nom-actif-field" translate="Preference.ReleveAffaire.Automatique"></label>

			<div [ngClass]="{ 'non-interactive': !isEditMode }">
				<btn-toggle formControlName="envoieAutomatique"></btn-toggle>
			</div>
		</div>
		<div class="row emails">
			<div class="col-md-4 form-group">
				<div class="cell-title form-label" [ngClass]="{ 'form-label-required': isEmail1Required }">
					{{ 'Preference.ReleveAffaire.Email1' | translate }}
				</div>
				<input
					class="form-control"
					formControlName="email1"
					[class.is-invalid]="form?.controls?.email1?.dirty && form?.controls?.email1?.invalid"
					*ngIf="isEditMode"
				/>
				<form-control-feedback [field]="form?.controls?.email1"></form-control-feedback>
				<span class="cell-value" *ngIf="!isEditMode">
					{{ form.value.email1 }}
				</span>
			</div>
			<div class="col-md-4 form-group">
				<div class="cell-title form-label">{{ 'Preference.ReleveAffaire.Email2' | translate }}</div>
				<input
					class="form-control"
					formControlName="email2"
					[class.is-invalid]="form?.controls?.email2?.dirty && form?.controls?.email2?.invalid"
					*ngIf="isEditMode"
				/>
				<form-control-feedback [field]="form?.controls?.email2"></form-control-feedback>
				<span class="cell-value" *ngIf="!isEditMode">
					{{ form.value.email2 }}
				</span>
			</div>
			<div class="col-md-4 form-group">
				<div class="cell-title form-label">{{ 'Preference.ReleveAffaire.Email3' | translate }}</div>
				<input
					class="form-control"
					formControlName="email3"
					[class.is-invalid]="form?.controls?.email3?.dirty && form?.controls?.email3?.invalid"
					*ngIf="isEditMode"
				/>
				<form-control-feedback [field]="form?.controls?.email3"></form-control-feedback>
				<span class="cell-value" *ngIf="!isEditMode">
					{{ form.value.email3 }}
				</span>
			</div>
		</div>

		<div class="date-modif" *ngIf="!isEditMode && preferenceReleveAffaires.lastDateModification">
			<p>
				{{
					'Preference.DerniereModification'
						| translate
							: {
									dateModification: preferenceReleveAffaires.lastDateModification | date: 'dd/MM/yyyy',
									heureModification: preferenceReleveAffaires.lastDateModification | date: 'HH',
									minuteModification: preferenceReleveAffaires.lastDateModification | date: 'mm',
									utilisateurModification: preferenceReleveAffaires.lastUtilisateurModification
							  }
				}}
			</p>
		</div>

		<div class="edit-btns text-end" *ngIf="isEditMode">
			<button type="button" class="btn btn-secondary btn-cancel" (click)="cancel()" [disabled]="preferenceService?.editLoading$ | async">
				{{ 'Actions.Cancel' | translate }}
			</button>
			<button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="preferenceService.editLoading$ | async">
				<loader-button-spinner [isShowButtonSpinner]="preferenceService.editLoading$ | async"></loader-button-spinner>
				{{ 'Actions.Confirm' | translate }}
			</button>
		</div>
	</form>
</content-block>

<ng-template #contentBlockActions>
	<button type="button" class="btn btn-primary" (click)="edit()" *ngIf="allowEdit && !isEditMode" [disabled]="anyEditMode$ | async">
		<span>
			<i class="far fa-pencil"></i>
			<loader-button-spinner [isShowButtonSpinner]="preferenceService.getLoading$ | async"></loader-button-spinner>
			{{ 'Actions.Edit' | translate }}
		</span>
	</button>
</ng-template>
